import React, { Component } from 'react';
import SaveTemplate from '../../assets/Save-template.png';
import EditTemplate from '../../assets/Edit-template.png';
import AddNewTemplate from '../../assets/Add-new-template.png';
import urls from '../../custom_libraries/urls';
import { get, post, put, del } from '../../custom_libraries/serverRequests';
import globalVariables from "../../custom_libraries/globalVariables";
import ResetIcon from '../../assets/icons8-reset-24.png';
import Alert from '@mui/material/Alert';
import CheckIcon from '@mui/icons-material/Check';
import DeleteIcon from "../../assets/icons8-trash-50.png";
import DialogBox from '../DialogBox';
import { Link } from 'react-router-dom';
import { Button } from '@mui/material';

class HealthPolicyTemplate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            template_name : '',
            template_hours : '',
            template_days : '',
            template_hd_capacity:'',
            create_new_template: false,
            template_list: [],
            isEditable: false, // Toggle for edit mode
            selectedTemplateID: null,
            success: false,
            error: false,
            success1: false,
            error1: false,
            deleteError: false,
            deleteSuccess: false,
            deleteCheck1: false,
            deleteCheck2: false,
            confirmDialog: {
                isOpen: false,
                title: '',
                subtitle: '',
            },
        }
    }

    componentDidMount() {
        this.handleFetchTemplate();
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            this.state.error !== prevState.error ||
            this.state.error1 !== prevState.error1 ||
            this.state.success !== prevState.success ||
            this.state.success1 !== prevState.success1 ||
            this.state.deleteSuccess !== prevState.deleteSuccess ||
            this.state.deleteError !== prevState.deleteError ||
            this.state.deleteCheck1 !== prevState.deleteCheck1 ||
            this.state.deleteCheck2 !== prevState.deleteCheck2
        ) {
            if (
                this.state.error ||
                this.state.error1 ||
                this.state.success ||
                this.state.success1 ||
                this.state.deleteSuccess ||
                this.state.deleteError ||
                this.state.deleteCheck1 ||
                this.state.deleteCheck2
            ) {
                setTimeout(() => {
                    this.setState({
                        error: false,
                        error1: false,
                        success: false,
                        success1: false,
                        deleteError: false,
                        deleteSuccess: false,
                        deleteCheck1: false,
                        deleteCheck2: false
                    });
                }, 3000); // 1 second
            }
        }
    }

    // handleInputChange = (e) => {
    //     this.setState({
    //         [e.target.name]: e.target.value
    //     });
    // }

    handleInputChange = (event) => {
        const { name, value } = event.target;
        this.setState({ [name]: value });
        if(this.state.create_new_template===true)
            {
                return
            }
        // If the user selects a template, populate hours and days
        if (name === "template_name") {
            const selectedTemplate = this.state.template_list.find((temp) => temp.id.toString() === value);
            if (selectedTemplate) {
                this.setState({
                    selectedTemplateID: selectedTemplate.id,
                    template_days: selectedTemplate.days,
                    template_hd_capacity: selectedTemplate.hd_capacity_alert
                });
            }
        }
    };

    handleFetchTemplate = async() => {

        try{
            let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
            console.log("--------auth tocken---------", access_tocken);
            let response = await get(urls.HEALTH_RECORDING_POLICY, );
            console.log("FetchTemplate API Response:", response)
            response = response.data;
            if (response) {
                console.log("res",response)
                this.setState({ template_list: response,
                    selectedTemplateID: response[0].id,
                    template_days: response[0].days,
                    template_hd_capacity: response[0].hd_capacity_alert
                 });
            } else {
                console.error("No data returned from the API");
                this.setState({ template_list: [] });
            }
        }

        catch (error) {
            console.error("Error fetching devices from API:", error);
        }
    }

    createNewTemplate= async() => {
        this.setState({
             create_new_template: true,
             isEditable: false,
             template_name:'',
             template_hours:'',
             template_days:'',
             template_hd_capacity:''
             });
    }

    handleEditTemplate = () => {
        this.setState({ 
            isEditable: true,
            create_new_template: false,
         });
    };

    handleSaveTemplate = async() => {
        let post_data = {
            "name" : this.state.template_name,
            "hours" : 0,
            "days" : this.state.template_days,
            "hd_capacity_alert": this.state.template_hd_capacity
        }

        post_data = JSON.stringify(post_data);
        console.log("------post-data in SaveTemplate---", post_data);

        try{
            let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
            console.log("--------auth tocken---------", access_tocken);
            let headers = {
                // 'content-type': 'application/json',
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': `Bearer ${access_tocken}`
            }
            let response = await post(urls.HEALTH_RECORDING_POLICY, post_data, headers);
            console.log("API Response:", response)
            if (response) {
                console.log("res",response);
                this.setState({ success: true });
                // setTimeout(() => {
                //     window.location.reload();
                // }, 3000); // 3 seconds delay
                this.resetToFetchedData();
            } else {
                console.error("No response returned from the API");
                this.setState({ error: true });
                // setTimeout(() => {
                //     window.location.reload();
                // }, 3000); // 3 seconds delay
                this.resetToFetchedData();
            }
        }

        catch (error) {
            console.error("Error fetching devices from API:", error);
        }
    }

    handleUpdateTemplate = async () => {
        try {
            let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
            const {selectedTemplateID} = this.state;
            const updatedTemplate = {
                id: this.state.template_name,
                // hours: this.state.template_hours,
                days: this.state.template_days,
                hd_capacity_alert: this.state.template_hd_capacity
            };
            let post_data = JSON.stringify(updatedTemplate);
            console.log("------post-data in update Template---", post_data);
    
            // Call API to save updated values
            let headers = {
                'content-type': 'application/json',
                // 'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': `Bearer ${access_tocken}`
            }
            const url = urls.MANAGE_HEALTH_RECORDING_POLICY(selectedTemplateID);
            console.log("------url in update Template---", url);

            let response = await put(url, post_data, headers);
            console.log("--handleUpdateTemplate--API Response:---", response);

            if (response) {
                console.log("res---",response)
                this.setState({ success1: true });
                this.resetToFetchedData();
                // setTimeout(() => {
                //     window.location.reload();
                // }, 3000); // 3 seconds delay
            } else {
                console.log("No response returned from the API")
                this.setState({ error1: true });
                this.resetToFetchedData();
                // setTimeout(() => {
                //     window.location.reload();
                // }, 3000); // 3 seconds delay
            }

        } catch (error) {
            console.error("Error saving template:", error);
        }
    };
    
    handleDelete = async () => {
        const {selectedTemplateID} = this.state
        try {
            // if(selectedTemplateID === 1){
            //     alert("you can not delete default template");
            //     return
            // }
            // if(selectedTemplateID === null ){
            //     alert("please select template first.");
            //     return
            // }
            console.log("------url in delete Template---");
            const url = urls.MANAGE_HEALTH_RECORDING_POLICY(selectedTemplateID);
            console.log("------url in update Template---", url);

            let response = await del(url);
            console.log("--handleUpdateTemplate--API Response:---", response);

            if (response) {
                console.log("res---",response)
                this.setState({ deleteSuccess: true });
                this.resetToFetchedData();
                // setTimeout(() => {
                //     window.location.reload();
                // }, 3000); // 3 seconds delay
            } else {
                console.log("No response returned from the API")
                this.setState({ deleteError: true });
                this.resetToFetchedData();
                // setTimeout(() => {
                //     window.location.reload();
                // }, 3000); // 3 seconds delay
            }
        }
        catch (error){
            console.error("Error saving template:", error);
        }
    }

    openDialog = (onConfirm) => {
        const {selectedTemplateID} = this.state
        if(selectedTemplateID === 1){
            // alert("you can not delete default template");
            this.setState({deleteCheck1:true});
            return
        }
        if(selectedTemplateID === null ){
            // alert("please select template first.");
            this.setState({deleteCheck2:true});
            return
        }
        this.setState({
          confirmDialog: {
            isOpen: true,
            title: 'Confirm Action',
            subtitle: "Are you sure, you want to delete this template?",
            onConfirm
          },
        });
      };

    closeDialog = () => {
        this.setState({
          confirmDialog: {
            ...this.state.confirmDialog,
            isOpen: false,
          },
        });
      };

    resetToFetchedData = () => {
        this.setState({
            create_new_template: false,
            isEditable: false,
            template_name: '', // Reset or set to fetched template name
            template_hours: '', // Reset or set to fetched hours
            template_days: '', // Reset or set to fetched days
            template_hd_capacity:''
        });
        // Optionally, fetch the data again to ensure the form is up-to-date
        this.handleFetchTemplate();
    };
    
render(){
    const { template_name, template_hours,selectedTemplateID, template_days, template_hd_capacity, create_new_template, template_list, isEditable, error, success, error1, success1, deleteError, deleteSuccess, confirmDialog, deleteCheck1, deleteCheck2} = this.state;
    return(
        <div style={{ display: 'flex', flexDirection: 'column' }}>

            <div className="side-by-side-container" style={{ flex: '2', marginLeft:'9%', marginTop:'1%', padding: '20px', overflowY: 'auto', gap:'50px' }}>
                <div className="health-setting-container">
                    <div className="form-section" >
                        { error ? (
                                <Alert severity="error">Server Error! New template  was not created.</Alert>
                            ) : success ? (
                                <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                                    "All set! New template  was created successfully."
                                </Alert>
                            ) : error1 ? (
                                <Alert severity="error">Server Error! Template info was not updated.</Alert>
                            ) : success1 ? (
                                <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                                    "All set! Template info was updated successfully."
                                </Alert>
                            ) : deleteCheck1 ? (
                                <Alert severity="warning">
                                    "You can not delete default template."
                                </Alert>
                            ) : deleteCheck2 ? (
                                <Alert severity="warning">
                                    "please select template first."
                                </Alert>
                            ): deleteError ? (
                                <Alert severity="error">
                                    "Error occured deleting the template!"
                                </Alert>
                            ) : deleteSuccess ? (
                                <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                                    "All set! Template deleted successfully."
                                </Alert>
                            ) : null} 
                            {create_new_template ? (
                                <div style={{width:'100%'}}>
                                <h4>Define Device/s' Recording Policy Template</h4>
                                <label>Template Name : </label>
                                <input
                                        type="text"
                                        name="template_name"
                                        placeholder="Enter template name"
                                        value={template_name}
                                        onChange={this.handleInputChange}
                                        style={{ paddingRight:'6px'}}
                                    />
                                {/* <label>Hours : </label>
                                <input
                                            type="number"
                                            name="template_hours"
                                            placeholder="Enter Hours"
                                            value={template_hours}
                                            onChange={this.handleInputChange}
                                        /> */}
                                <label>Days : </label>
                                <input
                                            type="number"
                                            name="template_days"
                                            placeholder="Enter Days"
                                            value={template_days}
                                            onChange={this.handleInputChange}
                                            style={{ paddingRight:'6px'}}
                                        />
                                <label>Set HD Capacity for alert : </label>
                                <input
                                            type="range"
                                            min="0"
                                            max="100"
                                            step="1"
                                            name="template_hd_capacity"
                                            placeholder="Enter HDD capacity percentage"
                                            value={template_hd_capacity}
                                            onChange={this.handleInputChange}
                                            style={{ paddingRight:'6px'}}
                                />
                                <span>{template_hd_capacity}%</span>
                                </div>
                             ):
                             (
                                <div style={{width:'100%'}}>
                                    <h4>Recording Policy Templates</h4>
                                    <label>Template Name : </label>
                                    <select
                                    name="template_name"
                                    placeholder="Enter template name"
                                    value={selectedTemplateID}
                                    onChange={this.handleInputChange}
                                    >
                                            
                                            {/* <option value="" disabled>Select Template to view</option> */}
                                        {(template_list|| []).map((temp) => (
                                        <option key={temp.id} value={temp.id}>
                                            {temp.name}
                                        </option>
                                    ))}
                                    </select>
                                    
                                    <label>Days : </label>
                                    <input
                                                type="number"
                                                name="template_days"
                                                // placeholder="Enter Days"
                                                value={template_days}
                                                onChange={this.handleInputChange}
                                                readOnly={!isEditable} // Disable input if not editable
                                                style={{
                                                    backgroundColor: isEditable ? "#f9f9f9" : "#fff",
                                                    border: isEditable ? "2px solid #4caf50" : "1px solid #ccc",
                                                    paddingRight:'6px'
                                                }}
                                                
                                            />
                                            {isEditable ? (
                                                        <>
                                                        <label>Set HD Capacity for alert : </label>
                                                            <input
                                                                type="range"
                                                                min="0"
                                                                max="100"
                                                                step="1"
                                                                name="template_hd_capacity"
                                                                value={template_hd_capacity}
                                                                onChange={this.handleInputChange}
                                                                style={{ paddingRight:'6px'}}
                                                            />
                                                            <span>{template_hd_capacity}%</span>
                                                        </>
                                                    ) : (
                                                        <>
                                                        <label>Set HD Capacity for alert : </label>
                                                        <input
                                                            type="number"
                                                            name="template_hd_capacity"
                                                            value={template_hd_capacity}
                                                            onChange={this.handleInputChange}
                                                            readOnly
                                                            style={{
                                                                backgroundColor: "#fff",
                                                                border: "1px solid #ccc",
                                                                paddingRight:'6px'

                                                            }}
                                                        />
                                                        </>
                                                    )
                                            }
                                    
                                </div>
                             )}
                                {/* Control icon visibility based on state */}
                                {create_new_template ? (
                                    <div style={{display:'flex', alignItems:'center', gap:'15px', marginTop:'5px'}}>
                                    {/* <img
                                        src={SaveTemplate}
                                        alt="Save template"
                                        title="Save"
                                        style={{ width: '35px', height: '35px', verticalAlign: 'middle' }}
                                        onClick={this.handleSaveTemplate}
                                    />&ensp; */}
                                    <Button
                                        onClick={this.handleSaveTemplate}
                                        variant="contained"
                                        sx={{
                                            // margin: '0 10px',
                                            padding: '4px 2px',
                                            fontSize: '14px',
                                            // width:'60px',
                                            minWidth: '60px',
                                            background: 'linear-gradient(145deg,rgb(69, 183, 81),rgb(87, 237, 132))',  // Primary color gradient
                                            boxShadow: 2,
                                            '&:hover': {
                                            background: 'linear-gradient(145deg,rgb(87, 197, 86),rgb(29, 170, 4))',  // Inverted gradient for hover effect
                                            },
                                            cursor: 'pointer',
                                        }}
                                    >
                                        {'Save'}
                                    </Button>
                                    <img
                                        src={ResetIcon} // Replace with your circular arrow icon path
                                        alt="Reset"
                                        title="Reset"
                                        style={{ width: '22px', height: '22px', verticalAlign: 'middle', cursor: 'pointer' }}
                                        onClick={this.resetToFetchedData}
                                    />
                                    </div>
                                ) : isEditable ? (
                                    <div style={{display:'flex', alignItems:'center', gap:'15px', marginTop:'5px'}}>
                                        {/* <img
                                            src={SaveTemplate}
                                            alt="Update template"
                                            title="Update Info"
                                            style={{ width: '35px', height: '35px', verticalAlign: 'middle', cursor: 'pointer' }}
                                            onClick={this.handleUpdateTemplate}
                                        />&ensp; */}
                                        <Button
                                        onClick={this.handleUpdateTemplate}
                                        variant="contained"
                                        sx={{
                                            // margin: '0 10px',
                                            padding: '4px 2px',
                                            fontSize: '14px',
                                            // width:'60px',
                                            minWidth: '60px',
                                            background: 'linear-gradient(145deg,rgb(69, 183, 81),rgb(87, 237, 132))',  // Primary color gradient
                                            boxShadow: 2,
                                            '&:hover': {
                                            background: 'linear-gradient(145deg,rgb(87, 197, 86),rgb(29, 170, 4))',  // Inverted gradient for hover effect
                                            },
                                            cursor: 'pointer',
                                        }}
                                    >
                                        {'Save'}
                                    </Button>
                                        <img
                                            src={ResetIcon} // Replace with your circular arrow icon path
                                            alt="Reset"
                                            title="Reset"
                                            style={{ width: '22px', height: '22px', verticalAlign: 'middle', cursor: 'pointer' }}
                                            onClick={this.resetToFetchedData}
                                        />
                                    </div>
                                ) : (
                                    <div style={{display:'flex', alignItems:'center', gap:'15px'}}>
                                        <img
                                            src={EditTemplate}
                                            alt="Edit template"
                                            title="Edit"
                                            style={{ width: '33px', height: '33px', cursor: 'pointer' }}
                                            onClick={this.handleEditTemplate}
                                        /> 
                                        <img
                                            src={AddNewTemplate}
                                            alt="Add new template"
                                            title="Add new template"
                                            style={{ width: '33px', height: '33px', cursor: 'pointer' }}
                                            onClick={this.createNewTemplate}
                                        /> 
                                        <img 
                                            src={DeleteIcon}
                                            alt="Delete template"
                                            title="Delete template"
                                            style={{ width: '30px', height: '24px', cursor: 'pointer'}}
                                            onClick={() => this.openDialog(this.handleDelete)}
                                        />
                                    </div>
                                )}
                    </div>
                    <DialogBox
                        confirmDialog={confirmDialog}
                        setConfirmDialog={(updatedDialog) =>
                            this.setState({ confirmDialog: updatedDialog })
                        }
                        onConfirm={this.state.confirmDialog.onConfirm} // Use the stored callback
                        onCancel={this.closeDialog}
                    />
                </div>
                <div style={{padding: '20px' }}>
                        <div className="form-section" style={{fontFamily: "Arial, sans-serif"}}>
                            <h4>How it work?</h4>
                            <p><span style={{color:'lightseagreen'}}>Hours :</span> <br/>
                            Look for recordings from the past so many hours.<br/><br/>
                            <span style={{color:'lightseagreen'}}>Days:</span> <br/>
                            Look for recordings from the past so many days.<br/><br/>
                            <span style={{color:'lightseagreen'}}>HD capacity</span><br/>
                            Percentage (%) that hard-drive can be full before receiving an alert.</p>
                        </div>
                </div>
            </div>
        </div>
    )
}
}

export default HealthPolicyTemplate;